import React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Menu, Table, Select, Tabs } from 'antd'
import styles from './index.scss'
import LineChart from 'containers/shared/LineChart'
import ICompareWithExampleChart from './ICompareWithExampleChart'
import ICompareWithToptenChart from './ICompareWithToptenChart'
import ICompareWithAllPie from './ICompareWithAllPie'
import IAreaMostTable from './IAreaMostTable'

const TabPane = Tabs.TabPane

const Option = Select.Option
const currentYear = new Date().getFullYear()
const yearList = Array(currentYear - 2018 + 1)
  .fill(0)
  .map((_, i) => String(2018 + i))
  .reverse()

const studyMinsFormatter = min =>
  min ? Math.round((Number(min) / 60) * 100) / 100 : 0

const percentFormatter = percent =>
  percent ? Math.round(Number(percent) * 100 * 100) / 100 : 0

const MenuRenderMap = {
  example: <ICompareWithExampleChart />,
  topten: <ICompareWithToptenChart />,
  all: <ICompareWithAllPie />,
}

class UStudyData extends ComponentExt {
  filedsTextMap = {
    sysStudyNum: '系统平均学习数量',
    areaStudyNum: '片区平均学习数量',
    sysStudyHour: '系统平均学习时长',
    areaStudyHour: '片区平均学习时长',
    sysStudyPercent: '系统平均视频完成度(%)',
    areaStudyPercent: '片区平均视频完成度(%)',
  }

  state = {
    loading: false,
    currentTablePage: 1,
    areaStudyData: [],
    areaStudyTrendData: [],
    currentComparison: 'topten',
  }

  componentDidMount() {
    this.fetchStudyData(currentYear)
    this.fetchStudyTrendData()
  }

  async fetchStudyData(year) {
    this.setState({ loading: true, myStudyData: [] })
    const { data } = await this.api.user.getAreaStudyData(year)
    const areaStudyData = []

    for (const val of data) {
      areaStudyData.push({
        ...val,
        month: val.the_date.split('-')[1],
        study: studyMinsFormatter(val.study),
        finish_percent: percentFormatter(val.finish_percent),
      })
    }

    this.setState({
      areaStudyData,
    })

    this.setState({ loading: false })
  }

  async fetchStudyTrendData() {
    const { my, sys } = await this.api.user.getAreaStudyChart()
    const areaStudyTrendData = []
    const {
      sysStudyNum,
      sysStudyHour,
      sysStudyPercent,
      areaStudyNum,
      areaStudyHour,
      areaStudyPercent,
    } = this.filedsTextMap

    my.forEach((val, key) => {
      areaStudyTrendData.push({
        month: val.the_date,
        [areaStudyNum]: Number(val.avg_articles),
        [areaStudyHour]: studyMinsFormatter(val.avg_study),
        [areaStudyPercent]: percentFormatter(val.finish_percent),
        [sysStudyNum]: Number(sys[key].avg_articles),
        [sysStudyHour]: studyMinsFormatter(sys[key].avg_study),
        [sysStudyPercent]: percentFormatter(sys[key].finish_percent),
      })
    })

    this.setState({
      areaStudyTrendData,
    })
  }

  handleChange = year => {
    this.fetchStudyData(year)
  }

  handleChangeComparisonClick = ({ key }) => {
    this.setState({
      currentComparison: key,
    })
  }

  handleChangeSectionClick = ({ key }) => {
    this.setState({
      currentSection: key,
    })
  }

  handleChangeTablePage = page => {
    this.setState({
      currentTablePage: page,
    })
  }

  // 直属区域
  renderAreaStudyTable = myStudyData => {
    const columns = [
      {
        title: '月份',
        dataIndex: 'month',
        className: 'columnCenter',
      },
      {
        title: '总学习时长(小时)',
        className: 'columnCenter',
        dataIndex: 'study',
      },
      {
        title: '视频学习数',
        className: 'columnCenter',
        dataIndex: 'articles',
      },
      {
        title: '视频完成度(%)',
        className: 'columnCenter',
        dataIndex: 'finish_percent',
        render: text => <span style={{ color: '#FF3C00' }}>{text}</span>,
      },
    ]
    return (
      <section>
        <h4 className={styles.chartTitle}>
          <span>直属区域</span>
          <Select
            defaultValue={String(currentYear)}
            onChange={this.handleChange}
            style={{ width: 100, marginLeft: 24 }}
          >
            {yearList.map(y => (
              <Option key={y} value={y}>
                {y}
              </Option>
            ))}
          </Select>
        </h4>
        <Table
          loading={this.state.loading}
          columns={columns}
          dataSource={myStudyData}
          bordered
          pagination={{
            current: this.state.currentTablePage,
            defaultPageSize: 6,
            onChange: this.handleChangeTablePage,
            hideOnSinglePage: true,
          }}
        />
      </section>
    )
  }

  // 我的学习趋势图
  renderMyStudyTrendChart = areaStudyTrendData => {
    return (
      <section>
        <h4 className={styles.chartTitle}>片区学习趋势图</h4>
        <LineChart
          data={areaStudyTrendData}
          filedsTextMap={this.filedsTextMap}
        />
      </section>
    )
  }

  render() {
    const { areaStudyData, areaStudyTrendData, currentComparison } = this.state
    return (
      <div className={styles.areaStudyData}>
        {this.renderMyStudyTrendChart(areaStudyTrendData)}
        {this.renderAreaStudyTable(areaStudyData)}
        <section>
          <Menu
            onClick={this.handleChangeComparisonClick}
            selectedKeys={[currentComparison]}
            mode="horizontal"
          >
            <Menu.Item key="example">与榜样片区的对比</Menu.Item>
            <Menu.Item key="topten">与前十片区的对比</Menu.Item>
            <Menu.Item key="all">与全部片区的对比</Menu.Item>
          </Menu>
          {MenuRenderMap[currentComparison]}
        </section>
        <IAreaMostTable />
      </div>
    )
  }
}

export default UStudyData
